import * as React from 'react';
import { useField } from 'formik';
import { CmdCalendar } from '@commander-services/gui-components';
import { useIntl } from 'react-intl';
import { IValidationRule } from '../../Services/FormikValidatorService';
// import './CmdCalendar/calendar.scss';
import { IGroupSelectVehicles } from '../Alarms/types';

export interface IOption {
  item: string;
  value: string;
  label?: string;
  tooltip?: string;
  disabled?: boolean;
  passed?: boolean;
}

export interface IGroupSelectOptions {
  [key: string]: IOption[];
}

export interface IGroupSelectOptionAction {
  item: string;
  value: string;
  title: string;
  icon: string;
  actionCallback: (event) => void;
}

interface ICmdFieldProps {
  component: React.ComponentType<any>;
  id: string;
  name: string;
  label: string;
  required?: boolean;
  type?: string;
  introOption?: string;
  introDisabled?: boolean;
  options?: IOption[] | IGroupSelectVehicles;
  rows?: number;
  step?: number;
  placeholder?: string;
  searchPlaceholder?: string;
  tooltip?: string;
  note?: string;
  currency?: string;
  columnClass?: string;
  gridTemplateColumns?: string;
  bossCheckbox?: string;
  warningMessage?: string;
  disabled?: boolean;
  noDecimal?: boolean;
  onChangeCallback?: (value: string | number) => void;
  onBlurCallBack?: (value: string | number) => void;
  enableTime?: boolean;
  noCalendar?: boolean;
  dateFormat?: string;
  selectButton?: string;
  resetButton?: string;
  dnd?: boolean;
  number?: number;
  maxFileSize?: number;
  acceptedFileTypes?: string[];
  url?: string;
  mode?: string;
  noTz?: boolean;
  rules?: IValidationRule[];
  readonly?: boolean;
  min?: number;
  showDetail?: () => void;
  showPartialDetail?: (value: string) => void;
  itemsNumber?: number;
  searchTooltip?: string;
  selectButtonTooltip?: string;
  resetButtonTooltip?: string;
  margin?: boolean;
  noteAfterInput?: string;
  language?: string | null;
  onFocusCallback?: () => void;
  changeCallback?: (value: string[], origEquipmentData?: any) => void;
  allowedRange?: Date[] | string[];
  allowedMaxDays?: number;
  initialValue?: Date[];
  disabledItems?: string[];
  beforeToday?: boolean;
  afterToday?: boolean;
}

export default function CmdField(props: ICmdFieldProps) {
  const [field, meta, helpers] = useField({ name: props.name });
  const { formatMessage: f } = useIntl();

  const getCalendarProps = () => {
    if (props.component === CmdCalendar) {
      return {
        language: localStorage.getItem('language'),
        rangesTranslations: {
          TODAY: f({ id: 'datepicker.TODAY' }),
          YESTERDAY: f({ id: 'datepicker.YESTERDAY' }),
          LAST_WEEK: f({ id: 'datepicker.LAST_WEEK' }),
          THIS_MONTH: f({ id: 'datepicker.THIS_MONTH' }),
          PREVIOUS_MONTH: f({ id: 'datepicker.PREVIOUS_MONTH' }),
          THIS_YEAR: f({ id: 'datepicker.THIS_YEAR' }),
          PREVIOUS_YEAR: f({ id: 'datepicker.PREVIOUS_YEAR' }),
        },
        calendarTranslations: {
          sunday: f({ id: 'date.sunday' }).slice(0, 2),
          monday: f({ id: 'date.monday' }).slice(0, 2),
          tuesday: f({ id: 'date.tuesday' }).slice(0, 2),
          wednesday: f({ id: 'date.wednesday' }).slice(0, 2),
          thursday: f({ id: 'date.thursday' }).slice(0, 2),
          friday: f({ id: 'date.friday' }).slice(0, 2),
          saturday: f({ id: 'date.saturday' }).slice(0, 2),
          ok: f({ id: 'table.apply' }),
          today: f({ id: 'datepicker.TODAY' }),
          yesterday: f({ id: 'datepicker.YESTERDAY' }),
          hours:
            localStorage.getItem('language') === 'en' ? 'Hr' : f({ id: 'date.hours' }).slice(0, 3),
          minutes: f({ id: 'date.minutes' }).slice(0, 3),
          seconds: f({ id: 'date.seconds' }).slice(0, 3),
        },
      };
    }
    return {};
  };

  if (props.component) {
    return <props.component {...field} {...meta} {...helpers} {...props} {...getCalendarProps()} />;
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <></>;
}
